import React from 'react';
import CreditDetails from '../../Components/CreditDetails';
import AppHeader from '../../Components/Common/Layout/AppHeader';
import { StyledDiv } from '../../Theme/CommonStyled';

const CreditDetailsPage: React.FC = () => {
  return (
    <>
      <AppHeader title="creditDetails" goBack />
      <StyledDiv
        id="notification-container"
        height={'calc(100vh - 60px)'}
        overflow={'auto'}>
        <CreditDetails />
      </StyledDiv>
    </>
  );
};

export default CreditDetailsPage;
